import type { JSX } from 'react';
import { Avatar } from '@wistia/vhs';
import type { ContactData } from './types';
import { useCommentContext } from './CommentContext';
import { isNonEmptyString } from '../../../../utilities/type-guards';

type CommentAvatarProps = {
  contact: ContactData | null | undefined;
  savedInitials?: string;
};

export const CommentAvatar = ({
  contact,
  savedInitials = '',
}: CommentAvatarProps): JSX.Element | null => {
  const { anonInitials } = useCommentContext();

  const { initials, name, isDeleted, avatar } = contact ?? {};

  const alternateInitials = isNonEmptyString(savedInitials) ? savedInitials : anonInitials;
  const contactInitials = initials ?? alternateInitials;

  return (
    <Avatar
      imageUrl={avatar?.thumbnailUrl}
      name={name}
      initials={isDeleted ? 'U' : contactInitials}
    />
  );
};
